import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Vetrate Panoramiche", to: "/vetrate-panoramiche-vepa", testid: "servizi" },
  { label: "Realizzazioni", to: "/realizzazioni-vetrate-panoramiche", testid: "portfolio" },
  { label: "Chi Siamo", to: "/azienda-vetrate-panoramiche-vepa", testid: "chi-siamo" },
  { label: "FAQ", to: "/faq-vetrate-panoramiche-vepa", testid: "faq" },
  { label: "Blog", to: "/blog", testid: "blog" },
  { label: "Meraviglia del Vetro", to: "/meraviglia-del-vetro", testid: "meraviglia" },
  { label: "Configuratore", to: "/configuratore", testid: "configuratore" },
  { label: "Traccia Ordine", to: "/traccia-ordine", testid: "traccia-ordine" },
  { label: "Lavora con Noi", to: "/lavora-con-noi", testid: "lavora-con-noi", highlight: true },
  { label: "Contatti", to: "/contatti-vetrate-panoramiche", testid: "contatti" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const check = () => setIsAdmin(!!localStorage.getItem("vd_token"));
    check();
    window.addEventListener("storage", check);
    return () => window.removeEventListener("storage", check);
  }, []);

  const go = (to) => {
    setOpen(false);
    navigate(to);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 backdrop-blur-xl border-b text-white ${
        scrolled ? "bg-[#26241f]/95 border-white/10 py-4 shadow-[0_2px_24px_rgba(0,0,0,0.25)]" : "bg-[#26241f]/85 border-white/10 py-5"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between">
        <Link
          to="/"
          data-testid="logo-link"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3"
        >
          <img src="/logo-vdi-light.png" alt="VETRO DESIGN ITALIA" className="h-12 md:h-16 w-auto object-contain" />
        </Link>

        <nav className="hidden md:flex items-center gap-5 lg:gap-8 md:ml-6 lg:ml-10">
          {LINKS.map((l) => (
            <Link
              key={l.testid}
              to={l.to}
              data-testid={`nav-${l.testid}`}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className={`link-underline text-sm tracking-wide uppercase transition-colors ${l.highlight ? "font-bold text-[#00CED1]" : "font-light text-white/80 hover:text-white"}`}
            >
              {l.label}
            </Link>
          ))}
          {isAdmin && (
            <Link
              to="/admin-ordini"
              data-testid="nav-admin"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="link-underline text-sm tracking-wide uppercase font-light text-teal-300 hover:text-teal-200 transition-colors"
            >
              Admin
            </Link>
          )}
          <Link
            to="/contatti-vetrate-panoramiche"
            data-testid="nav-cta-preventivo"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="text-sm tracking-wide uppercase border border-white/40 text-white px-6 py-2.5 hover:bg-white hover:text-black transition-colors duration-300"
          >
            Richiedi Preventivo
          </Link>
        </nav>

        <button className="md:hidden" data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X strokeWidth={1} /> : <Menu strokeWidth={1} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#26241f] border-t border-white/10 mt-4" data-testid="mobile-menu">
          <div className="flex flex-col px-6 py-4">
            {LINKS.map((l) => (
              <button
                key={l.testid}
                data-testid={`mobile-nav-${l.testid}`}
                onClick={() => go(l.to)}
                className={`py-3 text-left text-sm uppercase tracking-wide border-b border-white/10 transition-colors ${l.highlight ? "font-bold text-[#00CED1]" : "text-white/85 hover:text-white"}`}
              >
                {l.label}
              </button>
            ))}
            {isAdmin && (
              <button
                data-testid="mobile-nav-admin"
                onClick={() => go("/admin-ordini")}
                className="py-3 text-left text-sm uppercase tracking-wide text-teal-300 hover:text-teal-200 border-b border-white/10 transition-colors"
              >
                Admin
              </button>
            )}
            <button data-testid="mobile-nav-cta" onClick={() => go("/contatti-vetrate-panoramiche")} className="mt-4 text-sm uppercase tracking-wide bg-white text-black py-3">
              Richiedi Preventivo
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
